var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsGoShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8058 25.5489C94.8129 17.1151 88.9673 9.992 81.2795 5.41093C73.5918 0.829862 64.5451 -0.921268 55.7032 0.460234C46.8613 1.84174 38.78 6.26905 32.8561 12.9769C26.9322 19.6847 23.5381 28.2514 23.2604 37.1963C23.1142 43.0462 24.1267 48.8924 26.3429 54.9823C28.9541 56.7156 31.6622 58.2982 34.454 59.7223C34.1878 59.1935 33.9253 58.6386 33.6591 58.0873C30.2428 50.8199 28.6754 44.0062 28.8216 37.3163C29.1329 24.4614 37.7278 12.2591 49.6901 7.66162C53.5143 6.18769 57.5766 5.42885 61.675 5.4229C66.4395 5.43062 71.1455 6.47342 75.4673 8.47912C79.4369 10.3119 82.9949 12.9282 85.9277 16.1709C88.8604 19.4137 91.1073 23.2158 92.5334 27.3489C93.8346 31.0801 94.4121 34.7851 94.4121 39.36C94.3409 44.295 93.0171 49.9762 90.5609 55.7998C92.2709 54.4536 93.9321 53.0061 95.5896 51.4199L98.8633 48.2924C99.5554 45.3811 99.9351 42.4043 99.9958 39.4125V39.39C100.063 34.685 99.3223 30.0034 97.8058 25.5489ZM75.4223 80.1633C72.7749 83.3658 69.8387 86.6395 66.6137 89.9845C65.2675 91.3794 63.775 92.8232 62.0387 94.4357C61.9232 94.5484 61.7933 94.6455 61.6525 94.7244C61.5447 94.6498 61.4408 94.5697 61.3412 94.4844C56.2043 89.718 51.4112 84.594 46.9977 79.1508C43.5315 78.0129 40.1599 76.6049 36.914 74.9396C42.3065 82.882 49.0676 90.6069 57.5163 98.5531C58.611 99.6508 60.0842 100.288 61.6337 100.334C63.0775 100.334 64.4987 99.7343 65.7962 98.5531C67.5999 96.8694 69.1899 95.3506 70.6111 93.8844C76.1709 88.2329 81.2731 82.1488 85.8697 75.6896C82.5802 77.5962 79.0723 79.0983 75.4223 80.1633Z",
    fill: "url(#paint0_radial_3795_43342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2008 55.226C97.5929 57.9405 95.6874 60.4673 93.5196 62.7597C90.0694 66.5324 86.009 69.6978 81.5085 72.1234C75.8958 75.1216 69.6283 76.6843 63.265 76.6721C56.7663 76.6721 49.4014 75.1308 41.099 71.2084C37.6852 69.5835 34.3874 67.7253 31.2291 65.6472C25.4657 61.8286 20.024 57.5457 14.958 52.8411C21.9882 58.9295 29.9739 63.8175 38.594 67.3084C45.1902 69.9334 52.7951 71.8346 60.9287 71.8346C69.672 71.8314 78.2646 69.5585 85.866 65.2384C89.2602 63.3276 92.468 61.1029 95.4471 58.5935C96.7221 57.536 97.9483 56.4073 99.2008 55.226Z",
    fill: "url(#paint1_radial_3795_43342)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11289 45.6937C8.33912 46.7512 9.52036 47.7861 10.6978 48.7986C11.0841 49.1361 11.4666 49.4736 11.8791 49.8336C12.3141 50.2199 12.6253 50.1449 12.9141 49.6649C12.9753 49.568 13.0572 49.4861 13.1541 49.4249C13.6116 49.1361 14.0916 48.8699 14.5491 48.6074C14.8603 48.4161 14.8603 48.2961 14.6203 48.0524C14.5063 47.9326 14.368 47.8386 14.2148 47.7765C14.0615 47.7144 13.8968 47.6857 13.7316 47.6924C13.0904 47.7223 12.4508 47.6082 11.8596 47.3583C11.2684 47.1085 10.7407 46.7293 10.3154 46.2487C7.97913 43.7437 5.66915 41.1937 3.35918 38.6925C3.03985 38.317 2.63417 38.0246 2.17696 37.8404C1.71974 37.6562 1.22466 37.5857 0.73421 37.635C0.0104677 37.7063 -0.203281 38.07 0.205464 38.67C0.612076 39.2216 1.04638 39.7523 1.5067 40.26C2.30169 41.175 3.09669 42.0637 3.86543 42.9787C3.98368 43.1215 4.05097 43.2996 4.05667 43.4849C4.15417 45.2887 4.22542 47.0962 4.32292 48.8999C4.34542 49.4286 4.80291 49.6949 5.09166 50.0811C5.09166 50.0811 5.30916 49.9836 5.35791 49.8899C5.66916 49.1924 5.9579 48.5174 6.24665 47.8199C6.50914 47.1149 6.82414 46.4399 7.11289 45.6937Z",
    fill: "url(#paint2_radial_3795_43342)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41553 40.4473C7.04177 41.1223 7.64176 41.7935 8.26801 42.4685C8.6055 42.8548 8.9655 43.2148 9.303 43.5748C9.3458 43.6401 9.41199 43.6866 9.48799 43.7048C9.56399 43.7229 9.64404 43.7113 9.71174 43.6723C10.5555 43.3123 11.3955 42.9485 12.2167 42.5885C12.5542 42.4423 12.528 42.3973 12.363 42.0823C12.003 41.4335 11.3992 41.5048 10.8217 41.4561C9.40178 41.373 8.00776 41.0391 6.70428 40.4698C6.63303 40.4473 6.58428 40.4211 6.51303 40.3986C6.50127 40.4133 6.48646 40.4252 6.46963 40.4336C6.4528 40.4421 6.43434 40.4467 6.41553 40.4473Z",
    fill: "url(#paint3_radial_3795_43342)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2445 26.3663H75.7595C75.542 26.1263 75.3245 25.8864 75.0846 25.6689C73.4313 24.0059 71.4697 22.6812 69.3096 21.7689C67.0692 20.8283 64.6633 20.3451 62.2334 20.3477H62.2109V14.2615H62.2334C66.4895 14.2595 70.6713 15.3769 74.3592 17.5016C78.0471 19.6262 81.1113 22.6834 83.2445 26.3663Z",
    fill: "url(#paint4_radial_3795_43342)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5182 38.5463C86.5189 42.4769 85.5654 46.349 83.7398 49.83C81.9141 53.3109 79.2708 56.2967 76.0368 58.5309C72.8028 60.7651 69.0748 62.1809 65.1731 62.6567C61.2713 63.1325 57.3124 62.6541 53.6363 61.2625C49.9601 59.871 46.6767 57.608 44.068 54.6677C41.4593 51.7275 39.6033 48.198 38.6594 44.3824C37.7154 40.5667 37.7118 36.579 38.6488 32.7616C39.5858 28.9443 41.4353 25.4114 44.0387 22.4664V39.9637H44.0874C44.2096 41.5651 44.5411 43.1435 45.0737 44.6587C45.1937 44.9962 45.3137 45.3337 45.4599 45.6449C46.2431 47.5121 47.343 49.2298 48.7111 50.7224C48.9286 50.9624 49.1461 51.2024 49.3861 51.4199C51.0735 53.1127 53.0784 54.4558 55.2859 55.3723C57.4935 56.2887 59.8601 56.7605 62.2503 56.7605C64.6405 56.7605 67.0072 56.2887 69.2147 55.3723C71.4222 54.4558 73.4272 53.1127 75.1146 51.4199C75.3546 51.2024 75.5721 50.9624 75.7896 50.7224C77.1384 49.2151 78.2361 47.5007 79.0408 45.6449C79.187 45.3074 79.307 44.9699 79.427 44.6587C80.1205 42.7035 80.4706 40.6432 80.462 38.5688H62.2297V32.4788H84.422C84.8157 32.4771 85.1976 32.6135 85.5011 32.8642C85.8046 33.115 86.0106 33.4643 86.0832 33.8513C86.3654 35.4005 86.511 36.9715 86.5182 38.5463Z",
    fill: "url(#paint5_radial_3795_43342)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7261 44.6362C71.7094 46.4111 70.2603 47.9002 68.5138 48.9649C66.7672 50.0296 64.7798 50.6355 62.7363 50.7261H62.1813C60.1147 50.7324 58.082 50.2012 56.2826 49.1849C56.1851 49.1361 56.1138 49.0874 56.0163 49.0386C54.1994 47.9659 52.6934 46.4382 51.6465 44.6063C50.5997 42.7743 50.0482 40.7012 50.0464 38.5913V17.4865C51.94 16.3988 53.9722 15.5726 56.0876 15.0303V37.9913C56.0816 38.3624 56.1143 38.7331 56.1851 39.0975C56.2877 40.5371 56.9132 41.8896 57.9438 42.9C58.5025 43.46 59.1666 43.9038 59.8978 44.2056C60.629 44.5075 61.4127 44.6615 62.2038 44.6587C62.3404 44.6618 62.477 44.6543 62.6125 44.6362H72.7261Z",
    fill: "url(#paint6_radial_3795_43342)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0249 -24.9833) scale(302.315 301.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-50.5988 -25.1818) scale(302.467 302.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.0603 -25.1731) scale(302.21 302.363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.1508 -25.21) scale(302.25 302.508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-30.3167 -25.1762) scale(302.616 302.355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.8795 -25.1688) scale(302.306 302.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3795_43342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1393 -25.1633) scale(302.361 302.344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08D6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#057FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#057DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0576FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0457FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#0340FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsGoShortLogo);
export default __webpack_public_path__ + "static/media/LetsGoShortLogo.414e42f668ad8040ab25d3f92975e6e6.svg";
export { ForwardRef as ReactComponent };